module.exports = __webpack_public_path__ + "media/images/flags/TF-66f74f4c218ca2daf06f7ba69d8021ae.svg";